import {NgModule} from '@angular/core';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {CustomTableModule} from './custom-table/custom-table-module';

import { MessageModalComponent } from "./message-modal/message-modal.component";
//table component
import {AlertBoxComponent} from './alert-box/alert-box.component';

import {FileUploadComponent} from './file-upload/file-upload.component';
import {FormMessageComponent} from './form-message/form-message.component';
import {NotFoundComponent} from './404/404.component';
import {TimePickerComponent} from './time-picker/time-picker.component';

import {FileUploadService} from './file-upload/file-upload.service'
// Pipes
import { EllipsisPipe } from "./pipes/ellipsis.pipe";
import {FilenameFilterPipe} from './filename-filter/filename-filter.pipe';
import { CustomUploaderModule } from './file-upload/custom-uploader/custom-uploader.module';
import { RequestDatePipe } from "./pipes/request-date.pipe";
import { FromNowPipe } from "./pipes/from-now.pipe";
import { FromNowDaysPipe } from "./pipes/from-now-days.pipe";
import { CitizenshipTypePipe } from "./pipes/citizenship-type.pipe";
import { DateDropdownComponent } from "./date-dropdown/date-dropdown.component";
import { AutoCompleteComponent } from './auto-complete/auto-complete.component';


@NgModule({
  imports: [
    CommonModule,
    NgbModule.forRoot(),
    FormsModule,
    CustomTableModule,
    ReactiveFormsModule,
    CustomUploaderModule
  ],
  declarations: [
    AlertBoxComponent,
    EllipsisPipe,
    TimePickerComponent,
    NotFoundComponent,
    FileUploadComponent,
    FilenameFilterPipe,
    FormMessageComponent,
    MessageModalComponent,
    RequestDatePipe,
    FromNowPipe,
    FromNowDaysPipe,
    CitizenshipTypePipe,
    DateDropdownComponent,
    AutoCompleteComponent
  ],
  exports: [
    AlertBoxComponent,
    EllipsisPipe,
    TimePickerComponent,
    NotFoundComponent,
    CommonModule,
    NgbModule,
    FormsModule,
    CustomTableModule,
    ReactiveFormsModule,
    FileUploadComponent,
    FilenameFilterPipe,
    FormMessageComponent,
    RequestDatePipe,
    FromNowPipe,
    FromNowDaysPipe,
    CitizenshipTypePipe,
    DateDropdownComponent,
    AutoCompleteComponent
  ],
  providers: [FileUploadService],
  entryComponents: [
    MessageModalComponent
  ]

})
export class SharedModule {
}
